import { render } from "./PvpBackButton.vue?vue&type=template&id=775434ca&scoped=true"
import script from "./PvpBackButton.vue?vue&type=script&lang=ts"
export * from "./PvpBackButton.vue?vue&type=script&lang=ts"

import "./PvpBackButton.vue?vue&type=style&index=0&id=775434ca&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-775434ca"

export default script